export default __webpack_public_path__ + "static/media/077-mark.22221eb4.svg";